import JobPaymentConfirm from '../modules/components/jobs/payment-confirm';

export default function setPaymentScripts () {
    if (!window.location.pathname.includes('/payment/confirm')) return;

    new JobPaymentConfirm();
}
